export default [
    {
        path: '/',
        meta: {},
        component: () => import('@/views/50/index')
    }
]
